import type { FC, Dispatch, SetStateAction } from "react";
import type { Props as SelectProps } from 'react-select';
import Select, { components } from "react-select";
import { useLocale } from "hooks";
import translation from "../translation";
import { responsive } from "utils/theme";

interface IProps {
    options: SelectProps['options'],
    activeTab: string;
    setActiveTab: Dispatch<SetStateAction<string>>
    goTab: (tabKey?: string) => Promise<void>;
    layout?: 'primary' | 'secondary',
}

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M0 0L5 5L10 0H0Z" fill="black" />
            </svg>
        </components.DropdownIndicator>
    );
};

const TabSelect: FC<IProps> = ({ options, activeTab, setActiveTab, goTab, layout = 'primary' }) => {
    const { locale, isRTL } = useLocale();
    return (<>
        <style global jsx>{`
        .react-select2__placeholder {
            font-size: 14px
         }
         .react-select2__control {
          padding: ${isRTL ? 6 : 8}px 16px; 
         }

          @media only screen and (min-width: ${responsive.xxxl}px) {
            .react-select2__placeholder {
              font-size: 18.67px
            }
            .react-select2__control {
              padding: ${isRTL ? layout === 'primary' ? 9 : 11.5 : 12.5}px 12px;
            }
          }
      `}</style>
        <Select
            classNamePrefix={'react-select2'}
            styles={{
                option: (provided, state) => ({
                    ...provided,
                }),
                control: (provided) => ({
                    ...provided,
                    // paddingRight: 8,
                    // paddingLeft: 4,
                    borderRadius: 8,
                    ...(layout === 'primary' && { width: 200 })

                }),
                indicatorSeparator: () => ({
                    display: "none",
                }),
            }}
            components={{ DropdownIndicator }}
            placeholder={translation[locale]?.OPTIONS_PLACEHOLDER}
            options={options}
            value={options?.find(item => item.value === activeTab) || null}
            isSearchable={false}
            onChange={(selected) => goTab(selected?.value)}
        />
    </>
    );
};

export default TabSelect;
